class BookAppointment extends HTMLElement {
  constructor() {
    super();

    this.embedLoaded = false;
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#BookAppointmentDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setBookAppointmentButtonAccessibility();
  }

  setBookAppointmentButtonAccessibility() {
    const bookAppointmentButtonLinks = document.querySelectorAll('a[href^="#book"]');
    if (!bookAppointmentButtonLinks) return;

    bookAppointmentButtonLinks.forEach((bookButtonLink) => {
      bookButtonLink.addEventListener('click', () => {
        this.open(bookButtonLink);
      });
    });
  }

  loadAcuityEmbed() {
    if (this.embedLoaded) return Promise.resolve();

    const container = this.querySelector('#AcuityEmbed');
    const loader = this.querySelector('.drawer-embed-loader');
    if (!container) return Promise.resolve();

    const iframeSrc = container.dataset.src;
    const embedScriptSrc = container.dataset.embedScript;

    if (!iframeSrc) return Promise.resolve();

    const iframe = document.createElement('iframe');
    iframe.src = iframeSrc;
    iframe.title = 'Schedule Appointment';
    iframe.width = '100%';
    iframe.height = '800';
    iframe.setAttribute('frameborder', '0');
    iframe.addEventListener(
      'load',
      () => {
        loader?.classList.add('hidden');
      },
      { once: true }
    );
    container.appendChild(iframe);

    this.embedLoaded = true;

    if (!embedScriptSrc) return Promise.resolve();

    if (document.querySelector(`script[src="${embedScriptSrc}"]`)) {
      return Promise.resolve();
    }

    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = embedScriptSrc;
      script.async = true;
      script.onload = resolve;
      script.onerror = reject;
      document.body.appendChild(script);
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    this.loadAcuityEmbed().catch(() => {
      this.querySelector('.drawer-embed-loader')?.classList.add('hidden');
    });

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = document.getElementById('BookAppointment');
        const focusElement =
          this.querySelector('.book-appointment__inner') || this.querySelector('.book-appointment__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('book-appointment', BookAppointment);
